export const galleryStoreCreator = function (setter) {
  return {
    hoveredAsset: null,
    setHoveredAsset: (hoveredAsset) => {
      setter(() => ({ hoveredAsset }))
    },
  }
}
